import { ChevronUpIcon, RootState } from '@umanforge/common';
import WarningTileComponent from './warning_tile.component';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Warning } from 'interfaces/warning.interface';
import { useDispatch, useSelector } from 'react-redux';
import { WarningService } from 'services/warning.service';


interface PlanningWarningProps {
  className?: string;
  planningId: string;
  onOpenWarning: ( taskId: string ) => void
  update: unknown
}

const PlanningWarningComponent = ( {
  className = '',
  planningId,
  onOpenWarning,
  update
} : PlanningWarningProps ) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const token = useSelector( ( state: RootState ) => { return state.token.value; } );
  const buttonRef = useRef<HTMLDivElement | null>( null );
  const panelRef = useRef<HTMLDivElement | null>( null );
  //const logger: LoggerService = new LoggerService( 'Warning Component' );
  const [ open, setOpen ] = useState<boolean>( false );
  const [ warnings, setWarnings ] = useState<Warning[]>( [] );

  useEffect( () => {
    fetchWarning();
  }, [ planningId, update ] );

  useEffect( () => {
    const handleClickOutside = ( event: MouseEvent ) => {
      if ( !open ) {
        return;
      }

      const target = event.target as Node;
      if ( buttonRef.current?.contains( target ) ) {
        return;
      }

      if ( panelRef.current && !panelRef.current.contains( target ) ) {
        setOpen( false );
      }
    };

    document.addEventListener( 'mousedown', handleClickOutside );

    return () => {
      document.removeEventListener( 'mousedown', handleClickOutside );
    };
  }, [ open ] );

  const fetchWarning = async () => {
    if ( planningId ) {
      const _warnings = await WarningService.getWarningsByPlanningId( planningId, token, dispatch );
      setWarnings( _warnings );
    }
    else {
      setWarnings( [] );
    }
  };

  if ( warnings.length === 0 ) {
    return <></>;
  }

  return (
    <div className={ className + ' w-full h-full p-1' }>
      <div className='relative py-1 flex justify-center'>
        <div
          ref={ buttonRef }
          id={'warning_button'}
          className={'flex items-center gap-2 justify-between w-fit px-5 py-2 rounded-xl border border-orange-300 bg-orange-200 hover:bg-orange-300 transition-colors duration-150 font-medium text-slate-700 cursor-pointer'}
          onClick={ () => { setOpen( !open ); } }
        >
          <label htmlFor={'warning_button'} className='w-fit px-2 text-center whitespace-nowrap'>
            { t( 'translation:see_warnings' ) }
          </label>

          <ChevronUpIcon className={ `p-1 ${ open && 'rotate-180' } transition` } />
        </div>

        { open &&
          <div
            ref={ panelRef }
            className='absolute left-1/2 z-50 mt-14 w-[30rem] max-w-[calc(100vw-2rem)] max-h-[40rem] -translate-x-1/2 overflow-y-auto overflow-x-hidden rounded-2xl border border-slate-200 bg-white/70 shadow-[0_12px_28px_rgba(15,23,42,0.08)] backdrop-blur-sm animate-[fadeInUp_0.22s_cubic-bezier(0.2,0.8,0.2,1)]'
            onMouseDown={ event => { return event.stopPropagation(); } }
          >
            <div className='space-y-1.5 p-1.5'>
              { warnings.map( ( warning, index ) => {
                return <WarningTileComponent
                  key={ index + '_' + warning.taskId }
                  warning={ warning }
                  onClick={ onOpenWarning }
                />;
              } ) }
            </div>
          </div>
        }
      </div>
    </div>
  );
};

export default PlanningWarningComponent;